import {Person} from './person';
import {Rating} from './rating';

export class Vote {
  public id: number;
  public sprintId: string;
  public ratings: Rating[];
  public comment: string;
  public person: Person;
  public date: Date;

  constructor(id: number, sprintId: string, ratings: Rating[], comment: string = null, person: Person = null, date: Date = null) {
    this.id = id;
    this.sprintId = sprintId;
    this.ratings = ratings;
    this.comment = comment;
    this.person = person;
    this.date = date;
  }
}
